import React, {Component} from 'react';
import {connect} from 'react-redux';
// import temp100 from '../img/100x100/img1.jpg';
// import MultiCarousel from '../components/home/MultiCarousel';
import {closeCartNotification} from '../actions/shopping-cart';
// import MiniProductCard from '../components/product/MiniProductCard';
import {moneyFormat} from '../assets/util';
import {Link} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';

class ItemAddedToCartNotify extends Component {

    constructor(props){
        super(props);

        this.renderItems = this.renderItems.bind(this);
    }

    renderItems(items){
        return _.map(items, (item, index) => {
            return (
                <div className="item" key={index}>
                    <div className="item-img">
                        <img alt="" src={item.image_cart} />
                    </div>
                    <div className="item-detail">
                        <div className="item-name">
                            <div className="brand">{item.brand_en}</div>
                            <div className="name">{item.mat_name}</div>
                            {/* <div className="price"><FontAwesomeIcon icon={["far", "times"]} /> {cart_latest_item.qty}</div> */}
                            <div className="price">{moneyFormat(item.net_price? item.net_price: item.mat_price, '฿')} {(item.net_price && item.net_price !== item.mat_price) && <span className="original-price">{moneyFormat(item.mat_price, '฿')}</span>} <FontAwesomeIcon icon={["far", "times"]} /> {item.qty}</div>
                        </div>
                        <div className="item-price">{moneyFormat((item.net_price? item.net_price: item.mat_price) * item.qty, '฿')}</div>
                    </div>
                </div>
            )
        })
    }

    render() {
        const {visible, cart_latest_item} = this.props;
        const item = cart_latest_item? cart_latest_item.item: {};
        if (visible) {
            return (
                <div className="bt-popup-backdrop">
                    <div className="bt-popup bt-popup-addtocart">
                        <div className="container" onClick={(e) => e.stopPropagation()}>
                            <label className="btn-close" onClick={this.props.closeCartNotification}><FontAwesomeIcon icon={["fal", "times"]} style={{height: "16px", width: "16px"}} /></label>
                            <span className="header"><FontAwesomeIcon icon={faCheckCircle} /> นำสินค้าเข้ารถเข็นแล้ว</span>
                            {item.length > 1 
                                ?   this.renderItems(item)
                                :   <div className="item">
                                        <div className="item-img">
                                            <img alt="" src={item.image_cart} />
                                        </div>
                                        <div className="item-detail">
                                            <div className="item-name">
                                                <div>
                                                    <div className="brand">{item.brand_en}</div>
                                                    <div className="name">{item.mat_name}</div>
                                                    <div className="variant">ตัวเลือกสินค้า : {item.variant_name_2}</div>
                                                </div>
                                                {/* <div className="price"><FontAwesomeIcon icon={["far", "times"]} /> {cart_latest_item.qty}</div> */}
                                                <div className="price">{moneyFormat(item.net_price? item.net_price: item.mat_price, '฿')} {(item.net_price && item.net_price !== item.mat_price) && <span className="original-price">{moneyFormat(item.mat_price, '฿')}</span>}</div>
                                            </div>
                                            <div className="item-quantity-totalprice">
                                                <div className="item-quantity"><FontAwesomeIcon icon={["far", "times"]} /><span className="quantity">{cart_latest_item.qty}</span></div>
                                                <div className="item-price">{moneyFormat((item.net_price? item.net_price: item.mat_price) * cart_latest_item.qty, '฿')}</div>
                                            </div>
                                            
                                        </div>
                                    </div>
                            }
                            <div className="buttons row">
                                <div className="col">
                                    <button className="btn btn-white w-100" onClick={this.props.closeCartNotification}>เลือกสินค้าเพิ่ม</button>
                                </div>
                                <div className="col">
                                    <Link to={`/checkout`} onClick={this.props.closeCartNotification}><button className="btn btn-black w-100">ดำเนินการชำระเงิน</button></Link>
                                </div>
                            </div>
                            {/* <div className="row">
                                <div className="col-12">
                                    <span className="color-light-gray font-size-10">หมายเหตุ สามารถซื้อได้สูงสุด 12 ชิ้นต่อรายการ และ รายละเอียดโปรโมชั่นจะถูกคำนวนอยู่ภายในหน้ารถเข็นสินค้าค่ะ</span>
                                </div>
                            </div> */}
                            {/* <div className="related-items">
                                <div className="header">You also like...</div>
                                <div className="d-none d-xl-block">
                                    <MultiCarousel slideToShow={3}>
                                        <div className="col-xl-4"><MiniProductCard /></div>
                                        <div className="col-xl-4"><MiniProductCard /></div>
                                        <div className="col-xl-4"><MiniProductCard /></div>
                                        <div className="col-xl-4"><MiniProductCard /></div>
                                    </MultiCarousel>
                                </div>
                                <div className="row d-flex d-xl-none">
                                    <div className="col-4"><MiniProductCard /></div>
                                    <div className="col-4"><MiniProductCard /></div>
                                    <div className="col-4"><MiniProductCard /></div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div></div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        visible: state.common.cart_notify,
        cart_latest_item: state.common.cart_latest_item,
    }
}
export default connect(mapStateToProps, {closeCartNotification})(ItemAddedToCartNotify)